/* ════════════════════════════════════════════════════════════
   Reliable Handyman — Promo configuration
   Single source of truth for the new-customer welcome offer.
   Change here, everything updates.
   ════════════════════════════════════════════════════════════ */

export const PROMO = {
  active: true,
  percentOff: 20,
  capDollars: 150,
  // End-of-month: update monthly to extend
  endDate: '2026-06-30',           // YYYY-MM-DD
  endDateLabel: 'June 30',         // human-readable label shown on site
  // Copy fragments used across the site
  shortHeadline: 'Welcome to the neighborhood',
  shortSubline: '20% off your first service — up to $150 off, through June 30.',
  longSubline: 'New customer? Your 20% welcome discount (up to $150 off) is on us — applied at your visit. Through June 30.',
  bannerText: 'Welcome to the neighborhood — 20% off your first service. Through June 30.',
  eyebrowLabel: 'WELCOME OFFER',
};

/**
 * Returns true if the promo should currently be displayed.
 * Combines the manual `active` flag with the endDate check.
 */
export function isPromoActive() {
  if (!PROMO.active) return false;
  const now = new Date();
  const end = new Date(PROMO.endDate + 'T23:59:59');
  return now <= end;
}
